var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('t-node-dialog-form',{attrs:{"data":_vm.data,"title":_vm.type.title},on:{"delete":_vm.handleDeleteNode,"save":_vm.handleSave,"close":_vm.handleClose}},[_c('t-simple-ls-form',{attrs:{"value":_vm.data.action,"schema":_vm.schema},on:{"input":_vm.update}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }